import React from 'react'

function ProfLicenseSaudPartner() {
  return (
      <div style={{ padding: '50px', fontSize: '10px' }}>
          <h1>تقدم هذه الخدمة للشركات الأجنبية التي ترغب في 
              <br />
              ممارسة أنشطة مهنية في المملكة مع شريك سعودي.
          </h1>
      </div>
  )
}

export default ProfLicenseSaudPartner